// extracted by mini-css-extract-plugin
export default {"impactSurveyPageLink":"ImpactSurveyPage_impactSurveyPageLink__S-+Zf"};